import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Box, Paper, Checkbox } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/CheckCircle';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import T from 'i18n-react';

const useStyles = makeStyles((theme) => ({
  container: {
    height: '100%',
  },

  '@media screen and (min-width: 767px)': {
    divider: {
      borderLeft: '1px solid #c4c8d0',
      paddingLeft: '20px',
      margin: '0 10px',
    },
    paper: {
      padding: '20px 40px',
      textAlign: 'left',
      border: '2px solid #C4C8D0',
      borderRadius: '8px',
      boxShadow: 'none',
    },
    paperSelected: {
      padding: '20px 40px',
      textAlign: 'left',
      border: '2px solid #005EFF',
      borderRadius: '8px',
      boxShadow: 'none',
    },
    checkbox: {
      top: '30%',
    },
  },
  '@media screen and (max-width: 767px)': {
    divider: {
      borderTop: '1px solid #c4c8d0',
      margin: '20px 0',
      padding: '20px 0',
    },
    paper: {
      padding: '20px',
      textAlign: 'center',
      border: '2px solid #C4C8D0',
      borderRadius: '8px',
      boxShadow: 'none',
    },
    paperSelected: {
      padding: '20px',
      textAlign: 'center',
      border: '2px solid #005EFF',
      borderRadius: '8px',
      boxShadow: 'none',
    },
    title: {
      textAlign: 'center',
    },
  },
  icon: {
    color: '#005EFF',
  },
}));

const CompliancePlanComponent = ({ handleChange, selectedPlan }) => {
  const classes = useStyles();

  return (
    <Box py={2}>
      <Paper className={selectedPlan === 'compliancePlan' ? classes.paperSelected : classes.paper}>
        <Grid container>
          <Grid item xs={12} sm={12} md={1}>
            <Checkbox
              classes={{ root: classes.checkbox }}
              icon={<RadioButtonUncheckedIcon fontSize='small' />}
              checkedIcon={<CheckIcon classes={{ root: classes.icon }} fontSize='small' />}
              onChange={handleChange}
              checked={selectedPlan === 'compliancePlan'}
              name='compliancePlan'
              color='primary'
            />
          </Grid>
          <Grid item xs={12} sm={12} md={4}>
            <Box fontSize='26px' fontWeight='bold' py={2} lineHeight='30px' textAlign='left'>
              {T.translate('iSource.buyerForm.selectionPlan.compliancePlan.title')}
            </Box>
            <Box fontSize='24px' fontWeight='normal' py={1} textAlign='left'>
              {T.translate('iSource.buyerForm.selectionPlan.compliancePlan.price')}
            </Box>
            <Box fontSize='12px' fontWeight='bold' py={1} textAlign='left'>
              {T.translate('iSource.buyerForm.selectionPlan.compliancePlan.subtitle1')}
            </Box>
            <Box fontSize='12px' fontWeight='bold' textAlign='left'>
              {T.translate('iSource.buyerForm.selectionPlan.compliancePlan.subtitle2')}
            </Box>
          </Grid>
          <Grid item xs={12} sm={12} md={7}>
            <div className={classes.divider}>
              <Box py={1} fontSize='16px' fontWeight='bold' color='#005EFF' textAlign='left'>
                {T.translate('iSource.buyerForm.selectionPlan.subscription')}
              </Box>
              <Box py={1} textAlign='left'>
                <Box display='block' fontWeight='bold' lineHeight='30px' color='#3A4861'>
                  {T.translate('iSource.buyerForm.selectionPlan.valueFeature')}
                </Box>
                <Box display='block' color='#3A4861' lineHeight='28px'>
                  {T.translate('iSource.buyerForm.selectionPlan.compliancePlan.contentTitle1')}
                </Box>
                <Box display='block' color='#3A4861' lineHeight='28px'>
                  {T.translate('iSource.buyerForm.selectionPlan.compliancePlan.contentTitle2')}
                </Box>
                <Box display='block' color='#3A4861' lineHeight='28px'>
                  {T.translate('iSource.buyerForm.selectionPlan.compliancePlan.contentTitle3')}
                </Box>
                <Box display='block' color='#3A4861' lineHeight='28px'>
                  {T.translate('iSource.buyerForm.selectionPlan.compliancePlan.contentTitle4')}
                </Box>
                <Box display='block' color='#3A4861' lineHeight='28px'>
                  {T.translate('iSource.buyerForm.selectionPlan.compliancePlan.contentTitle5')}
                </Box>
                <Box display='block' color='#3A4861' lineHeight='28px'>
                  {T.translate('iSource.buyerForm.selectionPlan.compliancePlan.contentTitle6')}
                </Box>
              </Box>
            </div>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
};

export default CompliancePlanComponent;
